<template>
  <nav>
    <ul>
      <li v-for="menu in menuData" :key="menu.id">
        <router-link
          :to="menu.link"
          :class="{
            active: menu.submenus && menu.submenus.some(sub => $route.path === sub.link) || $route.path === menu.link
          }"
        >
          {{ menu.title }}
          <i v-if="menu.submenus" class="fas fa-angle-down"></i>
        </router-link>
        <ul v-if="menu.submenus" class="submenu">
          <li v-for="(submenu, i) in menu.submenus" :key="i">
            <router-link
              :to="submenu.link"
              :class="{ active: $route.path === submenu.link }"
            >
              {{ submenu.title }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'HeaderNavMenu',
  data() {
    return {
      menuData: [
        {
          id: 1,
          title: "Home",
          link: "/",
        },
        {
          id: 2,
          title: "About Us",
          link: "/about",
        },
        {
          id: 3,
          title: "Products",
          link: "/shop",
        },
        {
          id: 4,
          title: "Contact Us",
          link: "/contact",
        },
       
      ],
    };
  },
  computed: {
    route() {
      return this.$route; // Access the current route
    },
  },
};
</script>

<style scoped>
/* .main-menu ul li:hover > a{
    color:#f03723
}
.main-menu ul li .active{
  color:#f03723
} */

</style>
